var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:`icon-sprite icon-sprite-${_vm.name}`,on:{"click":function($event){return _vm.$emit('click', $event)},"mousedown":function($event){return _vm.$emit('mousedown', $event)}}},[_c('use',{attrs:{"xlink:href":`#icon-${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }